/* eslint-disable import/no-named-as-default */
import { Stack, Text } from 'native-base';
import { Controller } from 'react-hook-form';

import Button from '../../../Button';
import Checkbox from '../../../Checkbox';
import ImageZone from '../../../Dropzone/ImageZone';
import Input from '../../../Input';
import InputSearchLocation from '../../../InputSearchLocation';
import Radio from '../../../Radio';
import Select from '../../../Select';
import TagGroup from '../../../Tags/TagGroup';
import TextArea from '../../../TextArea';
import {
  IInputItemsRender,
  IInputsProps,
  INPUT_COMPONENT_TYPES,
} from './types';

const renderInput = ({
  component,
  inputProps,
  formState,
  name,
  ...rest
}: IInputItemsRender) => {
  switch (component) {
    case INPUT_COMPONENT_TYPES.INPUT:
      return (
        <Input
          name={name}
          errorMessage={formState.errors[name]?.message as string}
          {...inputProps}
          {...rest}
        />
      );
    case INPUT_COMPONENT_TYPES.TEXT_AREA:
      return (
        <TextArea
          name={name}
          errorMessage={formState.errors[name]?.message as string}
          {...inputProps}
          {...rest}
        />
      );
    case INPUT_COMPONENT_TYPES.SELECT:
      return (
        <Controller
          name={name}
          control={rest.control}
          render={({ field: { onChange } }) => (
            <Select
              name={name}
              errorMessage={formState.errors[name]?.message as string}
              onChange={onChange}
              {...inputProps}
              {...rest}
            />
          )}
        />
      );
    case INPUT_COMPONENT_TYPES.DYNAMIC_INPUT:
      return (
        <TagGroup
          name={name}
          errorMessage={formState.errors[name]?.message as string}
          {...inputProps}
          {...rest}
        />
      );
    case INPUT_COMPONENT_TYPES.RADIO:
      return (
        <Radio
          name={name}
          errorMessage={formState.errors[name]?.message as string}
          {...inputProps}
          {...rest}
        />
      );
    case INPUT_COMPONENT_TYPES.CHECKBOX:
      return (
        <Checkbox
          name={name}
          errorMessage={formState.errors[name]?.message as string}
          {...inputProps}
          {...rest}
        />
      );
    case INPUT_COMPONENT_TYPES.LOCALE:
      //FIXME: Create controlled component
      return (
        <Controller
          name={name}
          control={rest.control}
          render={({ field: { onChange } }) => (
            <InputSearchLocation onChangeValue={onChange} />
          )}
        />
      );
    case INPUT_COMPONENT_TYPES.DROPZONE_AREA:
      return (
        <Controller
          name={name}
          control={rest.control}
          render={({ field: { onChange, value } }) => {
            return (
              <ImageZone
                defaultImage={value}
                filesField={name}
                handleDropFile={onChange}
                {...inputProps}
                {...rest}
              />
            );
          }}
        />
      );
    case INPUT_COMPONENT_TYPES.ACTIVITY_METRICS:
      return (
        <Stack space={4}>
          <Stack space={2}>
            <Text color="gray.600" fontSize="xl">
              Activity Metrics
            </Text>
            <Text color="gray.600" fontSize="sm" fontWeight="400">
              Tell volunteers how you will measure the success of this activity.
            </Text>
          </Stack>

          <Input
            name={name}
            errorMessage={formState.errors[name]?.message as string}
            {...inputProps}
            {...rest}
          />
        </Stack>
      );

    case INPUT_COMPONENT_TYPES.UPLOAD_FILES:
      //Fix this
      return (
        <Stack>
          <input {...inputProps} {...rest} />

          <Button
            leftIconName="upload"
            leftIconSize={16}
            leftIconColor="primary.600"
            bgColor="primary.50"
            // onPress={open}
          >
            <Text color="primary.600" fontSize="14" fontWeight="500">
              Upload Files
            </Text>
          </Button>
        </Stack>
      );
    default:
      return (
        <Input
          name={name}
          errorMessage={formState.errors[name]?.message as string}
          {...inputProps}
          {...rest}
        />
      );
  }
};

export const useFormFieldsRenderController = ({
  control,
  items,
  options,
  formState,
}: IInputsProps) => {
  return { control, items, options, formState, renderInput };
};
